const getDomainGym = () => {};

export default getDomainGym;
